export var getCellData = function (cell, lang) {
    var _a, _b;
    var dataI18n = cell.dataI18n;
    return ((_b = (_a = dataI18n === null || dataI18n === void 0 ? void 0 : dataI18n[lang]) !== null && _a !== void 0 ? _a : 
    // find first non-empty
    dataI18n === null || dataI18n === void 0 ? void 0 : dataI18n[Object.keys(dataI18n).find(function (l) { return dataI18n[l]; })]) !== null && _b !== void 0 ? _b : {});
};
//# sourceMappingURL=getCellData.js.map